import { queryOptions } from '@tanstack/react-query';
import API from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';

export const usersMeQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.usersMe,
    queryFn: API.users.getUsersMe,
    staleTime: Infinity,
  });
